import { render, staticRenderFns } from "./PieChartCard.vue?vue&type=template&id=2136b7bf&scoped=true"
import script from "./PieChartCard.vue?vue&type=script&lang=js"
export * from "./PieChartCard.vue?vue&type=script&lang=js"
import style0 from "./PieChartCard.vue?vue&type=style&index=0&id=2136b7bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136b7bf",
  null
  
)

export default component.exports